import { render } from "./WhatsappSystemEdit.vue?vue&type=template&id=9129b096&scoped=true"
import script from "./WhatsappSystemEdit.vue?vue&type=script&lang=js"
export * from "./WhatsappSystemEdit.vue?vue&type=script&lang=js"

import "./WhatsappSystemEdit.vue?vue&type=style&index=0&id=9129b096&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9129b096"]])

export default __exports__